<template>
  <nav class="NavBar d-flex flex-row">
    <div class="NavBar__logo">
      <router-link :to="{ name: 'home' }">
        <Logo :company="company" />
      </router-link>
    </div>
    <p class="NavBar__description align-self-center my-0 ml-3 pl-3">
      <span class="ml-2">
        EV Prognose kaart - {{ townName }}
      </span>
    </p>
    <MapControls v-if="hasMapControls" />
  </nav>
</template>

<script>
import { image } from 'helper/assets'
import Logo from 'atom/branding/Logo'
import MapControls from 'molecule/MapControls'

import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',
  components: {
    Logo, MapControls
  },
  data() {
    return {
      company: 'EV Consult'
    }
  },
  computed: {
    ...mapGetters('config', {
      townName: 'name'
    }),
    hasMapControls() {
      return this.$route.meta.layout === 'map'
    }
  },
  methods: {
    image
  }
}
</script>

<style lang="scss">
.NavBar {
  height: 70px;
  background: #081736; // white;
  box-shadow: 0px -1px 0px 0px rgba(223,226,229,1) inset;
  user-select: none;

  &__logo {
    width: 250px;
    height: 100%;
    padding: 7px;
  }
  &__description {
    color: white;
    text-transform: uppercase;
  }
  .form-group {
    margin-bottom: 0
  }
}
</style>
